var $5713ddd83ea7a336$exports = {};
$5713ddd83ea7a336$exports = {
    "replaceMessage": `\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{30C9}\u{30ED}\u{30C3}\u{30D7}\u{3057}\u{3066}\u{7F6E}\u{63DB}`
};


export {$5713ddd83ea7a336$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
